import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import CommercialPage from "@/pages/CommercialPage";

export const Route = createFileRoute("/commercial")({
  head: () => pageHead("Commercial Solutions", "AI-enabled solutions for commercial enterprises across financial services, healthcare, technology, manufacturing, retail, and professional services.", "/commercial", false),
  component: CommercialPage,
});
